export const ACCESS_TOKEN_COOKIE_SUFFIX = '_accessToken';
export const REFRESH_TOKEN_COOKIE_SUFFIX = '_refreshToken';
export const ID_TOKEN_COOKIE_SUFFIX = '_idToken';
export const USER_DATA_COOKIE_SUFFIX = '_data';
export const USER_COOKIE_PREFIX = 'user';